import { setPageTitle } from '../../../utils/utilities'

import PostTradeForm from '../../Forms/PostTradeForm'

const PostTrade = () => {
  setPageTitle('Post Trade')

  return (
    <div className="flex w-full">
      <PostTradeForm />
    </div>
  )
}

export default PostTrade
